module.exports = __webpack_public_path__ + "img/EMT-LICA_PLC.1b4b0de0.png";